import React, { Component } from 'react';
import { Button } from "../index";
import { Row, Col, ModalBody, Modal } from "react-bootstrap";
import './messageBox.scss';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { resetMessageBox } from '../../../redux/actions/messageBoxActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        messageBox: state.messageBox
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    resetMessageBox
};

/**
 * Date     :   2020-06-22
 * Author   :   Dinushka Rukshan
 * Remarks  :   Global message box with redux state
 */
class MessageBox extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    };

    handleCallBackFunction(response) {
        if (this.props.messageBox.callBackFunction != null) {
            this.props.resetMessageBox();
            this.props.messageBox.callBackFunction(response);
        } else {
            this.props.resetMessageBox();
        }
    };

    render() {
        const headerIcon = this.props.messageBox.isConfirmation ? "fas fa-question-circle"
            : (this.props.messageBox.className === "error" || this.props.messageBox.className === "warning") ? "fas fa-exclamation-circle"
                : this.props.messageBox.className === "success" ? "fas fa-check-circle" : "fas fa-info-circle";
        return (
            <div>
                <Modal size="md" centered className="message-box" show={this.props.messageBox.show === undefined ? false : this.props.messageBox.show}>
                    <ModalBody>
                        <Row className={`message-box-header-${this.props.messageBox.className}`}>
                            <Col md="12">
                                <i id="id_message_box_header_icon" className={headerIcon}></i>
                                <h5>{this.props.messageBox.title === undefined ? "" : this.props.messageBox.title}</h5>
                                <div className='message-close-btn' onClick={() => { this.props.resetMessageBox(); }}>X</div>
                            </Col>
                        </Row>
                        <Row className="message-box-body">
                            <Col md="12">
                                <p style={{ whiteSpace: "pre-line" }}>
                                    {this.props.messageBox.content === undefined ? "" : this.props.messageBox.content}
                                </p>
                            </Col>
                        </Row>
                        <Row style={{ margin: 0, float: "right", paddingBottom: "15px" }}>
                            {
                                this.props.messageBox.className === "success" ?
                                    <Col md="12">
                                        <Button sm primary style={{ display: this.props.messageBox.isConfirmation ? "" : "none", marginRight: "5px" }} onClick={() => { this.handleCallBackFunction(true) }}>Yes</Button>
                                        <Button sm secondary style={{ display: this.props.messageBox.isConfirmation ? "" : "none", marginRight: "5px" }} onClick={() => { this.handleCallBackFunction(false) }}>No</Button>
                                        <Button sm primary style={{ display: this.props.messageBox.isConfirmation ? "none" : "" }} onClick={() => { this.handleCallBackFunction(true) }}>Ok</Button>
                                    </Col>
                                    : <Col md="12">
                                        {
                                            this.props.messageBox.content === "Thank you for choosing to shop at Keells Online.!\nPlease Login or Sign Up to proceed." ?
                                                <>
                                                    <Button sm secondary style={{ display: this.props.messageBox.isConfirmation ? "" : "none", marginRight: "5px" }} onClick={() => { this.handleCallBackFunction(true) }}>Login</Button>
                                                    <Button sm style={{ display: this.props.messageBox.isConfirmation ? "" : "none", marginRight: "5px" }} onClick={() => { this.handleCallBackFunction(false) }}>Sign Up</Button>
                                                    <Button sm secondary style={{ display: this.props.messageBox.isConfirmation ? "none" : "" }} onClick={() => { this.handleCallBackFunction(true) }}>Ok</Button>
                                                </>
                                                :  this.props.messageBox.content === "Please take a moment to refresh your password and continue enjoying a safe and smooth shopping journey with Keells Online." ?
                                                <>
                                                    <Button sm secondary style={{ display: this.props.messageBox.isConfirmation ? "" : "none", marginRight: "5px" }} onClick={() => { this.handleCallBackFunction(true) }}>Yes</Button>
                                                    <Button sm style={{ display: this.props.messageBox.isConfirmation ? "" : "none", marginRight: "5px" }} onClick={() => { this.handleCallBackFunction(false) }}>No</Button>
                                                    <Button sm secondary style={{ display: this.props.messageBox.isConfirmation ? "none" : "" }} onClick={() => { this.handleCallBackFunction(true) }}>Reset</Button>
                                                </>
                                                :<>
                                                <Button sm secondary style={{ display: this.props.messageBox.isConfirmation ? "" : "none", marginRight: "5px" }} onClick={() => { this.handleCallBackFunction(true) }}>Yes</Button>
                                                <Button sm style={{ display: this.props.messageBox.isConfirmation ? "" : "none", marginRight: "5px" }} onClick={() => { this.handleCallBackFunction(false) }}>No</Button>
                                                <Button sm secondary style={{ display: this.props.messageBox.isConfirmation ? "none" : "" }} onClick={() => { this.handleCallBackFunction(true) }}>Ok</Button>
                                            </>
                                        }

                                    </Col>
                            }
                        </Row>
                    </ModalBody>
                </Modal>

            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageBox);
